import React, { memo } from "react";
import classNames from "classnames";
import { ChatFile } from "./components/chat-file";
import { ChatPhoto } from "./components/chat-photo";
import { ChatVideo } from "./components/chat-video";
import { ChatText } from "./components/chat-text";
import { ChatBubbleProps, getAttachmentsByType } from ".";
import baseStyles from "./chat-bubble.module.scss";

const ChatBubble = ({
  className = "",
  messageType,
  text = "",
  timestamp,
  attachments = [],
  theme,
  ...props
}: ChatBubbleProps) => {
  const styles = theme || baseStyles;
  const hasAttachments = !!attachments.length;
  const { images, videos, files } = getAttachmentsByType(attachments);
  const hasMedia = !!videos.length || !!images.length;

  return (
    <div
      className={classNames(styles.chatBubble, className, {
        [styles.mediaBubble]: hasMedia,
      })}
      data-message-type={messageType}
      {...props}
    >
      {hasAttachments && (
        <div className={styles.attachments}>
          {images.map((image, index) => (
            <ChatPhoto image={image} key={index} />
          ))}
          {videos.map((video, index) => (
            <ChatVideo video={video} key={index} />
          ))}
          {files.map((file, index) => (
            <ChatFile file={file} key={index} />
          ))}
        </div>
      )}
      <ChatText
        text={text}
        messageType={messageType}
        timestamp={timestamp}
        hasMedia={hasMedia}
      />
    </div>
  );
};

export default memo(ChatBubble);
